/**
 * vue-custom-element
 * 该provider依赖 vue-custom-element模块，使用前确认是否已安装
 */
import Vue from 'vue'
import vueCustomElement from './widget-libs/vue-custom-element'

// 批量导入全局组件
const files = require.context("@/custom-components", true, /\.component\.js$/);

/**
 * @class VueCustomElementProvider
 * @classdesc vue组件适配
 */
export default class VueCustomElementProvider {
    constructor(proc) {
        this.proc = proc;
        this.$root = proc.$root;
        this.$Application = proc.make('Application')
        this.init();
    }

    components = new Map();

    VueComponents = {};

    init() {
        Vue.use(vueCustomElement);
        files.keys().forEach((path) => {
            const module = files(path);
            module.default(Vue, this.proc);
        });
    }

    /**
     * 创建vue自定义的组件
     * @param {string} name 
     * @param {VueComponent} methods 
     * @param { vueCustomElement.options } options 
     */
    createComponent(name, methods, options = {}) {

        let component = Vue.customElement(name, methods, options)
        this.components.set(name,component)
        if (options.style) {
            this.Style(options.style)
        }
    }

    /**
     * 
     * @param {string} name 组件的名称
     * @returns {Vue.Component} vue组件
     */
    getComponent(name){
        return this.components.get(name)
    }

    /**
     * 创建vue应用
     * @param {Object} matedata 应用元数据
     * @param {VueComponent} VueComponent vue模板组件
     * @returns {Vue}
     */
    createApp(matedata, VueComponent, callback) {
        
       
        
        let full = typeof matedata.full === 'undefined' ? true : matedata.full;
        this.$Application.register(matedata, (app) => {

            let component = Vue.extend(VueComponent);
            component.prototype.$App = app;
            let vm = new component().$mount();
            let el = app.createFullWindow();
            if(!full){
                // 可拖动的窗口
                let win = app.createWindow(matedata)
                el = win.$content.el
            }
            el.appendChild(vm.$el);
            this.VueComponents[matedata.name] = vm;
            app.destroy = () => {
                el.removeChild(vm.$el);
                vm.$destroy();
            }
            app.once('Application.open',(e)=>{
                matedata.open && matedata.open(vm)
            })
            app.once('Application.destroy',(e)=>{
                matedata.close && matedata.close(vm)
                vm.$destroy()
            })
            callback && callback(app, vm);
        })

        
    }

    /**
     * 销毁vue组件
     * @param {String} appName 
     */
    destroy(appName) {
        let app = this.$Application.Applications[appName];
        if (app) {
            Reflect.deleteProperty(this.VueComponents, appName)
            app.app.close();
            app.app.destroy();
        }
    }

    /**
     * 设置css样式
     * @param {string|json} styleString 
     */
    Style(styleString) {
        let style = document.createElement('style');
        style.type = 'text/css';
        if (typeof styleString === 'string') {
            try {
                style.appendChild(document.createTextNode(styleString));
            } catch (ex) {
                style.styleSheet.cssText = styleString;
            }
        } else {
            let css = '';
            for (let key in json) {
                css += key + ':' + json[key] + ';';
            }
            try {
                style.appendChild(document.createTextNode(css));
            } catch (ex) {
                style.styleSheet.cssText = css;
            }

        }
        let head = document.getElementsByTagName('head')[0];
        head.appendChild(style);
    }
}